import React from 'react';
import { useCart } from '../hooks/useCart';
import CartItem from '../components/cart/CartItem';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import EmptyCart from '../components/cart/EmptyCart';
import { useAuth } from '../context/AuthContext';

const CartPage = () => {
  const { 
    cartItems, 
    totalItems, 
    totalPrice, 
    updateQuantity, 
    removeFromCart, 
    clearCart 
  } = useCart();

  if (totalItems === 0) {
    return <EmptyCart />;
  }

  return (
    <div className="bg-softRose min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header with back button */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Your Shopping Cart ({totalItems})</h1>
          <Link 
            to="/" 
            className="text-pinkAccent hover:text-pink-700 font-medium flex items-center gap-1"
          >
            <span>←</span>
            <span>Continue Shopping</span>
          </Link>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Cart Items Column */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-sm divide-y divide-gray-200">
              {cartItems.map(item => (
                <CartItem
                  key={item.id}
                  item={item}
                  onUpdateQuantity={(newQty) => updateQuantity(item.id, newQty)}
                  onRemove={() => removeFromCart(item.id)}
                />
              ))}
            </div>

            {/* Action Buttons */}
            <div className="mt-4 flex justify-between">
<Link
  to="/"
  className="inline-flex items-center gap-1 px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pinkAccent"
>
  ← Back to Home
</Link>
              <Button 
                onClick={clearCart}
                variant="danger"
              >
                Clear Entire Cart
              </Button>
            </div>
          </div>

          {/* Order Summary Column */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-4">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Order Summary</h2>
              
              <div className="space-y-4">
                <div className="flex justify-between">
                  <span className="text-gray-600">Subtotal ({totalItems} {totalItems === 1 ? 'item' : 'items'})</span>
                  <span className="font-medium">${totalPrice.toFixed(2)}</span>
                </div>
                
                <div className="flex justify-between">
                  <span className="text-gray-600">Shipping</span>
                  <span className="font-medium">Calculated at checkout</span>
                </div>
                
                <div className="border-t border-gray-200 pt-4 flex justify-between">
                  <span className="text-lg font-medium">Total</span>
                  <span className="text-lg font-bold">${totalPrice.toFixed(2)}</span>
                </div>
              </div>

<Link
  to="/checkout"
  className="w-full mt-6 flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-pureWhite bg-pinkAccent hover:bg-pinkAccent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pinkAccent transition-colors duration-200"
>
  Proceed to Checkout
</Link>

              <p className="mt-4 text-center text-sm text-gray-500">
                or{' '}
                <Link 
                  to="/" 
                  className="text-pinkAccent hover:text-pink-700 font-medium"
                >
                  Continue Shopping
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;